
export const KB = 1024;
export const MB = KB * 1024;
export const GB = MB * 1024;

export function getShortFileSize(size: number) {
  if (size > 0.8 * GB) {
    return `${(size / GB).toFixed(2)} GB`;
  }

  if (size > 0.8 * MB) {
    return `${(size / MB).toFixed(2)} MB`;
  }

  if (size > 0.8 * KB) {
    return `${(size / KB).toFixed(2)} KB`;
  }

  return `${size} bytes`;
}